import request from './request'

//用户面试添加
export function addUserInterview(data) {
  return request({
    url: '/api/interview/add',
    method: 'post',
    data
  })
}

//用户面试列表
export function getUserInterviewList(data) {
  return request({
    url: '/api/interview/list',
    method: 'get',
    params: data
  })
}


// 用户投递面试记录列表
export function getUserDeliveryInterviewList(data) {
  return request({
    url: '/api/delivery/list',
    method: 'get',
    params: data
  })
}

// 投递面试记录
export function createDelivery(data) {
  return request({
    url: '/api/delivery/submit',
    method: 'post',
    data
  })
}

// 批量投递面试记录
export function batchCreateDelivery(data) {
  return request({
    url: '/api/delivery/submit/batch',
    method: 'post',
    data
  })
}


//用户面试删除
export function deleteUserInterview(id) {
  return request({
    url: `/api/interview/delete?id=${id}`,
    method: 'delete'
  })
}

//批量删除
export function batchDeleteUserInterview(ids) { 
  return request({
    url: '/api/interview/batchDelete',
    method: 'delete',
    data: {
      ids: ids
    }
  })
}
//用户面试更新
export function updateUserInterview(id, name) {
  return request({
    url: '/api/interview/update',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      id: id,
      interview_name: name
    }
  })
}

//用户面试更新
export function updateInterviewResult(data) {
  return request({
    url: '/api/interview/updateUrls',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

//获取面试数据
export function getInterviewData(id) {
  return request({
    url: `/api/interview/getInterviewResult`,
    method: 'get',
    params: {
      interviewId: id
    }
  })
}

//面试完成
export function finishInterview(id) {
  return request({
    url: `/api/interview/finishInterview`,
    method: 'post',
    data: {
      interviewId: id
    }
  })
}

//获取最近删除记录
export function getLastDeleteInterview() {
  return request({
    url: `/api/interview/getLastDeleteInterview`,
    method: 'get'
  })
}

//恢复最近删除记录
export function restoreInterview(id) {
  return request({
    url: `/api/interview/restoreInterview/${id}`,
    method: 'post'
  })
}